module.exports = __webpack_public_path__ + "img/chevron-down-black.c62ff574.svg";